import { PmsAvailableAppointmentModelBase } from "./PmsAvailableAppointmentModel.base"


/* A graphql query fragment builders for PmsAvailableAppointmentModel */
export { selectFromPmsAvailableAppointment, pmsAvailableAppointmentModelPrimitives, PmsAvailableAppointmentModelSelector } from "./PmsAvailableAppointmentModel.base"

/**
 * PmsAvailableAppointmentModel
 *
 * An available appointment for practice's PMS integration
 */
export const PmsAvailableAppointmentModel = PmsAvailableAppointmentModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
